;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.5";import * as Sentry from '@sentry/nextjs';
import { initBotId } from 'botid/client/core';
import { sanitizeSentryBreadcrumb, sanitizeSentryEvent } from './utils/sentry-sanitizer.mjs';

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || 'https://9b25dc71a4014961a8c16470eb089333@o305004.ingest.sentry.io/6105343',
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    })],
    beforeSend: sanitizeSentryEvent,
    beforeBreadcrumb: breadcrumb => sanitizeSentryBreadcrumb(breadcrumb),
  });
}
 
// Define the paths that need bot protection.
// These are paths that are routed to by your app.
// These can be:
// - API endpoints (e.g., '/api/checkout')
// - Server actions invoked from a page (e.g., '/dashboard')
// - Dynamic routes (e.g., '/api/create/*')
 
initBotId({
  protect: [
    {
      path: '/api/careers/apply/',
      method: 'POST',
    },
    // Protect both URL forms: BotID matches the path before any redirect.
    { path: '/api/models-consultation', method: 'POST' },
    { path: '/api/models-consultation/', method: 'POST' },
    { path: '/api/models-callback', method: 'POST' },
    { path: '/api/models-callback/', method: 'POST' },
    {
      path: '/api/callback/',
      method: 'POST',
    },
    {
      path: '/api/contact/',
      method: 'POST',
    },
    {
      path: '/api/interest-hair/',
      method: 'POST',
    },
    {
      path: '/api/register-interest/',
      method: 'POST',
    },
    {
      path: '/api/callback/',
      method: 'post',
    },
    {
      path: '/api/contact/',
      method: 'post',
    },
    {
      path: '/api/interest-hair/',
      method: 'post',
    },
    {
      path: '/api/register-interest/',
      method: 'post',
    },
  ],
});
